import { AnimationMixer, MathUtils } from 'three';

export function createEnemyAnim(gltfScene, variant = 'grunt') {
  const root = gltfScene?.scene || gltfScene;
  const clips = gltfScene?.animations || root?.animations || [];
  const mixer = root && clips.length ? new AnimationMixer(root) : null;
  const actions = {};
  for (const clip of clips) actions[clip.name] = mixer.clipAction(clip).play();
  return { root, mixer, actions, variant, hurt: 0, dead: false, time: 0, attackPulse: 0 };
}

export function updateEnemyAnim(animState, velocity, attacking = false, dt = 0) {
  if (!animState) return;
  animState.time += dt;
  animState.mixer?.update(dt);
  animState.hurt = Math.max(0, animState.hurt - dt * 4);
  animState.attackPulse = Math.max(attacking ? 0.12 : 0, (animState.attackPulse || 0) - dt * 5.2);
  if (animState.mixer) return;

  const speed = velocity?.length?.() || 0;
  const run = MathUtils.clamp(speed / 5, 0, 1);
  const chibi = animState.root?.children?.find?.((c) => c.userData?.assetModel);
  if (chibi) {
    animateChibi(chibi, animState, velocity, run);
    return;
  }

  const parts = animState.root?.userData?.parts;
  if (!parts) return;

  const stride = Math.sin(animState.time * MathUtils.lerp(4, 10, run)) * run;
  const attack = animState.attackPulse * 3.2;
  const hurt = animState.hurt * 0.35;
  if (parts.leftArm) parts.leftArm.rotation.x = 0.42 + stride * 0.35 + attack - hurt;
  if (parts.rightArm) parts.rightArm.rotation.x = 0.42 - stride * 0.35 + attack - hurt;
  if (parts.leftLeg) parts.leftLeg.rotation.x = -stride * 0.45;
  if (parts.rightLeg) parts.rightLeg.rotation.x = stride * 0.45;
  if (parts.body) parts.body.rotation.z = Math.sin(animState.time * 6) * run * 0.05 + hurt * 0.45;
}

function animateChibi(model, animState, velocity, run) {
  const { time, hurt } = animState;
  const basePosition = model.userData.basePosition;
  const baseRotation = model.userData.baseRotation;
  const baseScale = model.userData.baseScale;
  const variantBoost = animState.variant === 'swarm' ? 1.35 : animState.variant === 'runner' ? 1.16 : 1;
  const step = Math.sin(time * MathUtils.lerp(4, 12.5, run) * variantBoost);
  const hop = Math.abs(step) * run;
  const attack = animState.attackPulse || 0;
  const speed = MathUtils.clamp((velocity?.length?.() || 0) / 10, 0, 1);

  model.position.x = (basePosition?.x || 0) + Math.sin(time * 17) * hurt * 0.035;
  model.position.y = (basePosition?.y || 0) + hop * 0.16 + attack * 0.12;
  model.position.z = (basePosition?.z || 0) - attack * 0.22;
  model.rotation.x = (baseRotation?.x || 0) + run * 0.22 + attack * 0.45 - hurt * 0.16;
  model.rotation.y = baseRotation?.y || 0;
  model.rotation.z = (baseRotation?.z || 0) + step * run * 0.11 + Math.sin(time * 19) * attack * 0.05 + (Math.random() - 0.5) * hurt * 0.32;

  const squash = hop * 0.1 + attack * 0.09 + hurt * 0.05;
  model.scale.set(
    (baseScale?.x || 1) * (1 + squash * 0.78),
    (baseScale?.y || 1) * (1 - squash * 0.55),
    (baseScale?.z || 1) * (1 + squash + speed * 0.035),
  );
}

export function triggerEnemyDeath(animState) {
  if (!animState) return;
  animState.dead = true;
  animState.root.rotation.x = -Math.PI / 2;
}

export function triggerEnemyHurt(animState) {
  if (animState) animState.hurt = 1;
}
